module.exports = __webpack_public_path__ + "img/23.d7ce50eb.png";